define('webshopAttributesGridView',[
  'module',
  'app',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'modalsAlertView',
  'webshopCategorySelectView',
  'multiSelectDropdownView',
  'webshopAttributesProductInfoView',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesGridView'
], function (
  Module,
  App,
  Backbone,
  Marionette,
  _,
  Settings,
  AlertView,
  CategorySelectView,
  MultiSelectDropdown,
  ProductInfoView,
  MatchingApi,
  Tpl
) {
  'use strict';

  var PAGE_SIZE = 50;
  var EMPTY = 'empty';

  // Grid product (one page) → the shape the rendering helpers expect. Only the fields needed
  // for the row and the pager are kept; the "info" modal fetches the full product by id.
  var wrapGridProduct = function (p) {
    var imagesUrl = Settings.configValue('webshop.imagesUrl') || '';
    var preview = p.picture ? imagesUrl.replace(/\/$/, '') + '/' + p.picture : Settings.get('notFoundImage');
    return {
      id: p.id,
      code: p.code,
      label: p.label,
      status: p.status,
      name: p.name,
      model: {
        getPreviewImageUrl: function () { return preview; },
        getOutdated: function () { return p.outdated; }
      }
    };
  };

  // Grid value (backend's GridValue) → the shape attribute_matching's name/labels/color expect.
  var wrapGridValue = function (v) {
    return {id: v.id, code: v.code, names: v.names || {}, extraParam1: v.color || v.param || null};
  };

  // Column filters in the URL: "1:11.12.empty,3:empty" → {1: ['11', '12', 'empty'], 3: ['empty']}
  var parseColumnFilters = function (text) {
    var filters = {};
    _.each(String(text || '').split(','), function (part) {
      var i = part.indexOf(':');
      var keyId = parseInt(part.substring(0, i), 10);
      var values = _.compact(part.substring(i + 1).split('.'));
      if (i > 0 && keyId && values.length)
        filters[keyId] = values;
    });
    return filters;
  };

  var formatColumnFilters = function (filters) {
    return _.map(filters, function (values, keyId) { return keyId + ':' + values.join('.'); }).join(',') || null;
  };

  // Grid of the products of a webshop category: one column per attribute, each cell a multiple
  // choice dropdown (the common MultiSelectDropdown, as in the PIM products supplier filter) of the
  // attribute's values. Supplier values (PIM import) are ticked and locked; "Validate" saves the
  // product's manual values (assign REPLACE).
  // Everything the screen shows (columns and their values, current page of products with their
  // canonical values) comes from one backend call (/categories/{id}/grid) that applies the
  // search, hide, column filters and sub-categories server-side.
  // options.meta: {languages, suppliers}
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-attributes-grid-view',

    regions: {
      categoryRegion: '.category-region'
    },

    ui: {
      table: '.grid-table',
      pager: '.am-pager',
      info: '.category-info',
      addColumn: 'select.add-column',
      search: 'input.product-search'
    },

    events: {
      'change @ui.addColumn': 'onAddColumn',
      'click .remove-column': 'onRemoveColumn',
      'input @ui.search': 'onSearch',
      'change select.column-mode': 'onModeChange',
      'click .clear-column-filters': 'onClearColumnFilters',
      'click .reload-grid': 'onReload',
      'change input.hide-outdated, input.hide-disabled': 'onHideChange',
      'change input.with-subcategories': 'onSubcategoriesChange',
      'click .product-info': 'onProductInfo',
      'click .prev': 'onPrev',
      'click .next': 'onNext'
    },

    initialize: function () {
      this.category = null;
      this.keys = [];
      this.keyValues = {};
      this.keyLabels = {};
      this.columns = [];
      this.products = [];
      this.productValues = {};
      this.total = 0;
      this.totalProducts = 0;
      this.first = 0;
      this.query = '';
      this.loading = false;
      this.dropdowns = [];
      this.hide = ProductInfoView.Helper.hideOptions();
    },

    serializeData: function () {
      if (this.withSub === undefined)
        this.withSub = (this.options.state || {}).sub === '1';
      return {hideHtml: ProductInfoView.Helper.hideHtml(this.hide), legendHtml: ProductInfoView.Helper.legendHtml(),
        subHtml: ProductInfoView.Helper.subHtml(this.withSub)};
    },

    onSubcategoriesChange: function () {
      this.withSub = this.$('input.with-subcategories').is(':checked');
      this.setState({sub: this.withSub ? '1' : null});
      this.first = 0;
      this.load();
    },

    onShow: function () {
      // State of the URL: category, search, columns, column kind
      var state = this.options.state || {};
      if (state.cat)
        this.category = {id: state.cat, code: state.catCode || ''};
      this.query = state.q || '';
      this.ui.search.val(this.query);
      this.mode = _.contains(['filters', 'attributes'], state.mode) ? state.mode : 'both';
      this.$('select.column-mode').val(this.mode);
      this.columns = state.cols ? _.compact(_.map(String(state.cols).split(','), function (id) { return parseInt(id, 10); })) : [];
      this.columnFilters = parseColumnFilters(state.cf);

      this.getRegion('categoryRegion').show(new CategorySelectView({
        model: new Backbone.Model({id: this.category ? this.category.id : '', code: this.category ? this.category.code : ''}),
        onChange: _.bind(function (model) {
          this.category = model.get('id') ? {id: model.get('id'), code: model.get('code')} : null;
          this.columns = [];
          this.first = 0;
          this.setState({cat: this.category ? this.category.id : null, catCode: this.category ? this.category.code : null, cols: null});
          this.load();
          return $.Deferred().resolve().promise();
        }, this)
      }));

      // Attribute keys for the "+ Add a column" dropdown (names, showInFilters / showInAttributes).
      MatchingApi.keys().done(_.bind(function (keys) {
        this.keys = _.sortBy(keys, function (k) { return MatchingApi.name(k).toLowerCase(); });
        if (!this.isDestroyed)
          this.render_();
      }, this)).fail(_.bind(this.showError, this));
      this.render_();
      if (this.category)
        this.load();
    },

    setState: function (changes) {
      if (this.options.onState)
        this.options.onState(changes);
    },

    onDestroy: function () {
      this.destroyDropdowns();
    },

    //----------------
    // Loading

    // One backend call returns everything the screen shows for the current state (page,
    // search, hide, column selection, column filters, sub-categories): the columns with
    // their values, the current page of products with their canonical values, and the
    // category's chosen filters.
    // The backend keeps the category's products a while (15 min): reload reads them again from the webshop.
    onReload: function () {
      this.load(true);
    },

    load: function (refresh) {
      if (!this.category) {
        this.products = [];
        this.productValues = {};
        this.total = 0;
        this.totalProducts = 0;
        this.render_();
        return;
      }
      var category = this.category;
      this.loading = true;
      this.render_();

      var params = {
        first: this.first,
        pageSize: PAGE_SIZE,
        lang: Settings.get('lang'),
        hideOutdated: !!this.hide.outdated,
        hideDisabled: !!this.hide.disabled,
        withSubcategories: !!this.withSub
      };
      if (refresh === true)
        params.refresh = true;
      if (this.query)
        params.search = this.query;
      if (this.mode && this.mode !== 'both')
        params.mode = this.mode;
      if (this.columns && this.columns.length)
        params.columns = this.columns.join(',');
      var cf = formatColumnFilters(this.columnFilters);
      if (cf)
        params.cf = cf;

      MatchingApi.categoryGrid(category.id, params).done(_.bind(function (grid) {
        if (this.isDestroyed || category !== this.category)
          return;
        this.loading = false;
        this.totalProducts = grid.totalProducts || 0;
        this.total = grid.total || 0;
        this.first = Math.max(0, grid.first || 0);
        this.columns = _.pluck(grid.columns || [], 'keyId');
        this.keyValues = {};
        this.keyLabels = {};
        _.each(grid.columns || [], function (col) {
          this.keyValues[col.keyId] = _.map(col.values || [], wrapGridValue);
        }, this);
        this.products = _.map(grid.products || [], wrapGridProduct);
        this.productValues = {};
        _.each(grid.products || [], function (p) {
          this.productValues[p.code] = {productCode: p.code, found: p.found, values: p.values || []};
        }, this);
        this.setState({cols: this.columns.join(',') || null});
        this.render_();
      }, this)).fail(_.bind(function (message) {
        this.loading = false;
        this.render_();
        this.showError(message || _.i18n('attributeMatching.categoryError', null, 'The products of the category could not be loaded'));
      }, this));
    },

    // Refresh one row after a save: refetch its canonical values.
    refreshProduct: function (code) {
      return MatchingApi.productValues([code]).done(_.bind(function (result) {
        _.each(result, function (pv) { this.productValues[pv.productCode] = pv; }, this);
        if (!this.isDestroyed)
          this.renderRow(code);
      }, this));
    },

    //----------------
    // Rendering (named render_ so Marionette's own render keeps the template / regions)

    // Column filter of each shown column: "(empty)" + the attribute's values, in its header.
    mountColumnFilters: function () {
      this.ui.table.find('.column-head').each(_.bind(function (i, head) {
        var keyId = parseInt($(head).data('key'), 10);
        var values = this.keyValues[keyId] || [];
        var labels = MatchingApi.labels(values);
        var dropdown = new MultiSelectDropdown({
          items: [{value: EMPTY, label: _.i18n('attributeMatching.emptyValue', null, '(empty)')}].concat(_.map(values, function (v) {
            return {value: String(v.id), label: labels[v.id]};
          })),
          selection: this.columnFilters[keyId] || [],
          labelHtml: _.bind(function (selection) {
            return '<i class="fa fa-filter"></i>' + (selection.length ? ' <span class="filter-count">' + selection.length + '</span>' : '');
          }, this),
          placeholder: '',
          searchPlaceholder: _.i18n('attributeMatching.searchValue', null, 'Search a value'),
          clearLabel: _.i18n('common.clear', null, 'Clear'),
          applyLabel: _.i18n('common.validate', null, 'Validate'),
          onApply: _.bind(function (picked) {
            if (picked.length)
              this.columnFilters[keyId] = picked;
            else
              delete this.columnFilters[keyId];
            this.first = 0;
            this.setState({cf: formatColumnFilters(this.columnFilters)});
            this.load();
          }, this)
        }).render();
        $(dropdown.el).addClass('column-filter' + (this.columnFilters[keyId] ? ' active' : ''))
          .attr('title', _.i18n('attributeMatching.filterColumn', null, 'Filter the products on this attribute'));
        $(head).find('.column-filter-region').append(dropdown.el);
        this.dropdowns.push(dropdown);
      }, this));
      this.$('.clear-column-filters').toggle(!_.isEmpty(_.pick(this.columnFilters, _.map(this.shownColumns(), String))));
    },

    onClearColumnFilters: function () {
      if (_.isEmpty(this.columnFilters))
        return;
      this.columnFilters = {};
      this.first = 0;
      this.setState({cf: null});
      this.load();
    },

    // Columns shown with the current column mode (both | filters only | attributes only).
    // The backend already applied the mode when choosing the columns to return, but a client-
    // side filter keeps rendering coherent when `this.mode` changed before `load()` returned.
    shownColumns: function () {
      var mode = this.mode;
      return _.filter(this.columns, function (keyId) {
        var key = _.findWhere(this.keys, {id: keyId});
        if (!key || mode === 'both')
          return true;
        return mode === 'filters' ? key.showInFilters : key.showInAttributes;
      }, this);
    },

    render_: function () {
      this.renderAddColumn();
      this.destroyDropdowns();
      this.ui.table.toggleClass('am-loading', !!this.loading);

      if (!this.category || this.loading) {
        this.ui.table.html('<div class="empty">' + (this.loading ?
          _.i18n('common.loading', null, 'Loading...') :
          _.i18n('attributeMatching.pickCategory', null, 'Pick a webshop category')) + '</div>');
        this.ui.pager.empty();
        if (!this.loading)
          this.ui.info.text('');
        return;
      }

      var page = this.products;

      var head = '<div class="grid-row head"><div class="cell fixed col-product">' + _.escape(_.i18n('common.product', null, 'Product')) + '</div>' +
        _.map(this.shownColumns(), function (keyId) {
          var key = _.findWhere(this.keys, {id: keyId});
          return '<div class="cell column-head" data-key="' + keyId + '">' +
            '<span class="column-name" title="' + _.escape(key ? key.code : '') + '">' + _.escape(key ? MatchingApi.name(key) : '#' + keyId) + '</span>' +
            (key && !key.showInFilters ? ' <span class="am-badge" title="' + _.escape(_.i18n('attributeMatching.notAFilterShort', null, 'Not a webshop filter')) + '">' +
              _.escape(_.i18n('attributeMatching.attribute', null, 'Attribute')) + '</span>' : '') +
            '<span class="column-filter-region"></span>' +
            '<span class="remove-column" title="' + _.escape(_.i18n('attributeMatching.hideColumn', null, 'Hide the column')) + '"><i class="fa fa-times"></i></span>' +
            '</div>';
        }, this).join('') + '</div>';

      var rows = _.map(page, this.rowHtml, this).join('');
      this.ui.table.html(head + (rows || '<div class="empty">' + _.i18n('attributeMatching.emptyCategory', null, 'No product in this category') + '</div>'));
      this.mountColumnFilters();
      this.mountDropdowns(this.ui.table.find('.grid-row'));

      var pageStart = this.first + 1;
      var pageEnd = this.first + this.products.length;
      var hasPrev = this.first > 0;
      var hasNext = pageEnd < this.total;
      this.ui.pager.html(
        '<span class="prev ' + (hasPrev ? '' : 'off') + '"><i class="fa fa-chevron-left"></i></span>' +
        '<span>' + (this.total ? pageStart : 0) + '–' + pageEnd + ' / ' + this.total + '</span>' +
        '<span class="next ' + (hasNext ? '' : 'off') + '"><i class="fa fa-chevron-right"></i></span>');
      this.ui.info.text(this.total === this.totalProducts ?
        this.totalProducts + ' ' + _.i18n('common.products', null, 'products') :
        this.total + ' / ' + this.totalProducts + ' ' + _.i18n('common.products', null, 'products'));
    },

    rowHtml: function (p) {
      var pv = this.productValues[p.code];
      var found = pv && pv.found;
      return '<div class="grid-row" data-code="' + _.escape(p.code) + '">' +
        '<div class="cell fixed col-product product-cell">' + ProductInfoView.Helper.cellHtml(p) + '</div>' +
        _.map(this.shownColumns(), function (keyId) {
          if (!found)
            return '<div class="cell disabled" title="' + _.escape(_.i18n('attributeMatching.noPimProduct', null, 'No PIM sheet: values cannot be assigned')) + '">—</div>';
          return '<div class="cell editable" data-key="' + keyId + '"></div>';
        }, this).join('') +
        '</div>';
    },

    rowElement: function (code) {
      return this.ui.table.find('.grid-row').filter(function () { return $(this).attr('data-code') === code; });
    },

    renderRow: function (code) {
      var p = _.findWhere(this.products, {code: code});
      var $row = this.rowElement(code);
      if (!p || !$row.length)
        return;
      this.destroyDropdowns(code);
      var $new = $(this.rowHtml(p));
      $row.replaceWith($new);
      this.mountDropdowns($new);
    },

    //----------------
    // Cell dropdowns (MultiSelectDropdown, created per visible cell)

    mountDropdowns: function ($rows) {
      $rows.find('.cell.editable').each(_.bind(function (i, cell) {
        var $cell = $(cell);
        var code = $cell.closest('.grid-row').attr('data-code');
        var keyId = parseInt($cell.data('key'), 10);
        var current = this.cellValues(this.productValues[code], keyId);
        var supplierIds = _.filter(_.keys(current), function (id) { return current[id].supplier; });

        var labels = this.valueLabels(keyId);
        var dropdown = new MultiSelectDropdown({
          items: _.map(this.keyValues[keyId] || [], function (v) {
            var supplier = _.contains(supplierIds, String(v.id));
            return {
              value: String(v.id),
              label: labels[v.id],
              disabled: supplier,
              hint: supplier ? _.i18n('attributeMatching.supplierShort', null, 'supplier') : '',
              title: supplier ? _.i18n('attributeMatching.supplierLocked', null, 'Supplier value (PIM import): change its matching to remove it') : ''
            };
          }),
          selection: _.keys(current),
          labelHtml: _.bind(function () { return this.cellChips(this.productValues[code], keyId) || '<span class="am-hint">—</span>'; }, this),
          placeholder: '—',
          searchPlaceholder: _.i18n('attributeMatching.searchValue', null, 'Search a value'),
          loadingLabel: _.i18n('attributeMatching.noValue', null, 'No value yet'),
          clearLabel: _.i18n('common.clear', null, 'Clear'),
          applyLabel: _.i18n('common.validate', null, 'Validate'),
          onApply: _.bind(function (picked) {
            var manual = _.map(_.difference(picked, supplierIds), function (id) { return parseInt(id, 10); });
            this.saveCell(code, keyId, manual);
          }, this)
        }).render();
        dropdown.code = code;
        $cell.append(dropdown.el);
        this.dropdowns.push(dropdown);
      }, this));
    },

    // Labels of the values of an attribute (computed once per column, not per cell).
    valueLabels: function (keyId) {
      this.keyLabels = this.keyLabels || {};
      if (!this.keyLabels[keyId])
        this.keyLabels[keyId] = MatchingApi.labels(this.keyValues[keyId] || []);
      return this.keyLabels[keyId];
    },

    // All dropdowns, or those of one product.
    destroyDropdowns: function (code) {
      this.dropdowns = _.filter(this.dropdowns, function (d) {
        if (code && d.code !== code)
          return true;
        d.destroy();
        return false;
      });
    },

    // The manual values of the cell after the change, sent as REPLACE.
    saveCell: function (code, keyId, manualIds) {
      var current = this.cellValues(this.productValues[code], keyId);
      var before = _.map(_.filter(_.keys(current), function (id) { return current[id].manual; }), function (id) { return parseInt(id, 10); });
      if (_.isEmpty(_.difference(before, manualIds)) && _.isEmpty(_.difference(manualIds, before)))
        return;
      this.rowElement(code).addClass('busy');
      MatchingApi.assign([code], keyId, manualIds, 'REPLACE').done(_.bind(function (result) {
        if (result.failed && _.keys(result.failed).length)
          this.showError(_.values(result.failed).join(', '));
        else if (result.webshopErrors && _.keys(result.webshopErrors).length)
          this.showError(_.i18n('attributeMatching.webshopNotSynced', null, 'Saved, but not sent to the webshop: %s')
            .replace('%s', _.values(result.webshopErrors).join(', ')));
        this.refreshProduct(code);
      }, this)).fail(_.bind(function (message) {
        this.showError(message);
        this.refreshProduct(code);
      }, this));
    },

    // Values of the product for one attribute: {valueKeyId: {supplier, manual, filter}}
    cellValues: function (pv, keyId) {
      var values = {};
      _.each(pv ? pv.values : [], function (v) {
        if (v.keyId !== keyId)
          return;
        var entry = values[v.valueKeyId] || (values[v.valueKeyId] = {supplier: false, manual: false, filter: false});
        entry[v.source === 'MANUAL' ? 'manual' : 'supplier'] = true;
        entry.filter = entry.filter || v.filter;
      });
      return values;
    },

    valueName: function (keyId, valueId) {
      var label = this.valueLabels(keyId)[valueId];
      return label || '#' + valueId;
    },

    cellChips: function (pv, keyId) {
      var values = this.cellValues(pv, keyId);
      return _.map(values, function (e, valueId) {
        valueId = parseInt(valueId, 10);
        var value = _.findWhere(this.keyValues[keyId] || [], {id: valueId});
        var color = MatchingApi.color(value);
        return '<span class="am-chip ' + (e.supplier ? '' : 'manual') + (e.filter ? '' : ' no-filter') + '">' +
          (color ? '<span class="swatch" style="background:' + _.escape(color) + '"></span>' : '') +
          _.escape(this.valueName(keyId, valueId)) + '</span>';
      }, this).join(' ');
    },

    //----------------
    // Columns

    renderAddColumn: function () {
      var shown = this.columns;
      var mode = this.mode;
      var options = _.filter(this.keys, function (k) {
        return !_.contains(shown, k.id) && (mode === 'both' || (mode === 'filters' ? k.showInFilters : k.showInAttributes));
      });
      this.ui.addColumn.html('<option value="">' + _.escape(_.i18n('attributeMatching.addColumn', null, '+ Add a column')) + '</option>' +
        _.map(options, function (k) {
          return '<option value="' + k.id + '">' + _.escape(MatchingApi.name(k)) +
            (k.showInFilters ? '' : ' ' + _.escape(_.i18n('attributeMatching.notFilterSuffix', null, '(not a filter)'))) + '</option>';
        }).join(''));
      this.ui.addColumn.prop('disabled', !this.category || this.loading);
    },

    onAddColumn: function () {
      var keyId = parseInt(this.ui.addColumn.val(), 10);
      if (!keyId)
        return;
      this.columns.push(keyId);
      this.first = 0;
      this.setState({cols: this.columns.join(',')});
      this.load();
    },

    onRemoveColumn: function (e) {
      e.stopPropagation();
      var keyId = parseInt($(e.currentTarget).closest('.column-head').data('key'), 10);
      this.columns = _.without(this.columns, keyId);
      delete this.columnFilters[keyId];
      this.setState({cols: this.columns.join(','), cf: formatColumnFilters(this.columnFilters)});
      this.load();
    },

    onModeChange: function () {
      this.mode = this.$('select.column-mode').val();
      this.first = 0;
      this.setState({mode: this.mode === 'both' ? null : this.mode});
      this.load();
    },

    onHideChange: function () {
      this.hide = {outdated: this.$('input.hide-outdated').is(':checked'), disabled: this.$('input.hide-disabled').is(':checked')};
      ProductInfoView.Helper.setHideOptions(this.hide);
      this.first = 0;
      if (this.category)
        this.load();
    },

    onProductInfo: function (e) {
      e.stopPropagation();
      var code = $(e.currentTarget).closest('.grid-row').attr('data-code');
      var product = _.findWhere(this.products, {code: code});
      if (!product || !product.id)
        return;
      // The grid endpoint returns only a thumbnail; the modal needs the texts and medias.
      var model = App.request('webshop.product.model', {id: product.id, code: code});
      model.fetch().done(_.bind(function () {
        if (this.isDestroyed)
          return;
        ProductInfoView.Helper.open({
          code: code,
          label: product.label,
          status: product.status,
          name: product.name,
          model: model
        });
      }, this)).fail(_.bind(function () {
        this.showError(_.i18n('attributeMatching.categoryError', null, 'The products of the category could not be loaded'));
      }, this));
    },

    //----------------
    // Search / paging

    onSearch: function () {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(_.bind(function () {
        var query = this.ui.search.val() || '';
        if (query === this.query)
          return;
        this.query = query;
        this.first = 0;
        this.setState({q: this.query});
        if (this.category)
          this.load();
      }, this), 250);
    },

    onPrev: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first = Math.max(0, this.first - PAGE_SIZE);
      this.load();
    },

    onNext: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first += PAGE_SIZE;
      this.load();
    },

    showError: function (message) {
      AlertView.prototype.open('', message);
    }
  });
});

